import { Injectable } from '@angular/core';

@Injectable()
export class PaymentCreation {
    public _creation : any [] = [
        { value:0, name: 'TODOS' },
        { value:1, name: 'Este Mes' },
        { value:2, name: 'Esta Semana' },
        { value:3, name: 'Hoy' } ,
        { value:4, name: 'Ayer' } ,
        { value:5, name: 'Semana Pasada' } ,
        { value:6, name: 'Mes Pasado' } ,
        { value:7, name: 'Rango' } 
      ];

    constructor() { }
  }


  @Injectable()
  export class PaymentStatus {
      public _status : any [] = [
          { value:0, name: 'TODOS' },
          { value:1, name: 'Pendiente'},
          { value:2, name: 'Confirmado'},
          { value:3, name: 'Cancelados' }
        ];
  
      constructor() { }
    }

    @Injectable()
    export class PaymentType {
        public _type : any [] = [
            { value:0, name: 'TODOS' },
            { value:1, name: 'Pago'},
            { value:2, name: 'Reverso'},
          ];
    
        constructor() { }
      }